<ng-container *ngIf="!hide">
  <div class="card">
    <div class="card-body">
      <div class="row no-gutters d-flex align-items-center">
        <div class="col-md-4">
          <img class="img-fluid br-5" [src]="image" />
        </div>
        <div class="col-md-8">
          <div class="card-body">
            <h3>Getting started</h3>
            <p class="section-header font-weight-light" [innerHtml]="header"></p>
            <small class="text-muted" [innerHtml]="subheader"></small>
          </div>
        </div>
      </div>
      <common-marketing-cards-with-numbers [marketingCards]="gettingStartedCards"></common-marketing-cards-with-numbers>
    </div>
  </div>

  <div class="bb-light my-4"></div>
</ng-container>
